

































/**
 * https://www.digitalocean.com/community/tutorials/vuejs-vue-modal-component
 */

import { Vue, Component } from "vue-property-decorator";
@Component
export default class ConfirmDelete extends Vue {
  protected closeModal(): void {
    this.$emit("close");
  }
}
